let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cbIau"), load("5v9Ee"), load("6XyGC")]).then(() => parcelRequire('cV69w'));